import React from 'react';
import styles from './styles.module.scss';

const ProgressBar = ({progress}) => {
    return (
        <div className={styles.progressContainer}>
            <div
                className={styles.progressCondition}
                style={{width: `${progress}%`}}
            />
        </div>
    )
};

export default ProgressBar;